import i18n from 'services/base/i18n';

export default {
  saveLoading: () => i18n.pgettext('Components|Popup Messages', 'Saving...'),
  saveSuccess: () => i18n.pgettext('Components|Popup Messages', 'Saved successfully!'),
  saveError: () => i18n.pgettext('Components|Popup Messages', 'Save failed. Please try again later.'),

  errorPermissionNotificationsMissing: () => i18n.pgettext('Components|Popup Messages', 'Please allow notifications to receive real-time updates from your Pangolin devices'),
  errorPermissionNotificationsBlocked: () => i18n.pgettext('Components|Popup Messages', 'Your browser settings is blocking Google services for push messaging.'),

  errorActionPangolinOffline: () => i18n.pgettext('Components|Popup Messages', 'Action failed. Is the pangolin online?'),
  errorActionPlanRequired: () => i18n.pgettext('Components|Popup Messages', 'Upgrade your plan to perform this action.'),
  errorActionGeneric: () => i18n.pgettext('Components|Popup Messages', 'Action failed. Please try again later.'),

  errorQueryPangolinOffline: () => i18n.pgettext('Components|Popup Messages', 'Query failed. Is the pangolin online?'),
  errorQueryPlanRequired: () => i18n.pgettext('Components|Popup Messages', 'Upgrade your plan to access this content.'),
  errorQueryGeneric: () => i18n.pgettext('Components|Popup Messages', 'Query failed. Please try again later.'),

  hostConnected: (host: string) => i18n.sprintf(i18n.pgettext('Components|Popup Messages', '%s was detected.'), host),
};
